import React, {
  useContext,
  useState
} from 'react';
import { flowRight } from 'lodash';
import {
  ELSPropsFromToastService,
  ELSWithToastService
} from '@els/els-component-toast-react';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import { ELSButton } from '@els/els-component-button-react';
import {
  ELSIcon,
  ELSTextBox
} from '@els/els-component-form-field-react';
import { AppContext } from '../app/AppProvider.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import { ChatDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import {
  validateStringLength,
  validateStringMinLength
} from '../../utilities/validator.utilities';
import { putChatAction } from '../app/app-state-actions.utilities';

export const ChatEditModalId = 'ChatEditModalId';

export type ChatEditModalPropsOnly = {
  chat: ChatDto;
}

export type ChatEditModalProps = ChatEditModalPropsOnly
  & ELSPropsFromToastService
  & ELSPropsFromModalService

export type ChatEditModalState = {
  title: string;
}

const defaultState: ChatEditModalState = {
  title: ''
};

const ChatEditModalComponent = (props: ChatEditModalProps) => {

  const {
    appState,
    setAppState,
    appStateRef
  } = useContext(AppContext);

  const [state, setState] = useState<ChatEditModalState>({
    ...defaultState,
    title: props.chat.title
  });

  const isTitleValid = (): boolean => {
    const titleTrimmed = state.title.trim();
    return titleTrimmed.length >= 1 && titleTrimmed.length <= 255;
  };

  return (
    <div className="c-els-modal">
      <div className="c-els-modal__window u-els-width-1o2 u-els-width-1o1@mobile">
        <div className="">
          <button
            type="button"
            className="c-els-modal__close"
            onClick={() => {
              props.modalService.closeModal(ChatEditModalId);
            }}
          >
            <ELSIcon name="close" size="1x" />
            <span className="u-els-hide-visually">Close this modal window</span>
          </button>

          <h3>Rename chat</h3>

          <div className="o-els-container">
            <ELSTextBox name="editChatTitleInput"
              value={state.title}
              validators={[
                          validateStringLength(state.title, 255, appState.messages.ENTRY_EXCEEDS_LENGTH_LIMIT),
                          validateStringMinLength(state.title, 1, appState.messages.VALUE_REQUIRED)
                        ]}
              changeHandler={(e, title) => {
                          setState((prevState) => {
                            return { ...prevState, title };
                          });
                        }}>
              <span className="u-els-hide-visually">Title</span>
            </ELSTextBox>
          </div>


          <div className="u-els-margin-top-2x">
            <FlexLayout modifiers={[FlexLayoutModifier.RIGHT, FlexLayoutModifier.GUTTERS]}>
              <FlexItem>
                <ELSButton
                  type="secondary"
                  preventAutoPending
                  onClick={() => {
                    props.modalService.closeModal(ChatEditModalId);
                  }}>
                  Cancel
                </ELSButton>
              </FlexItem>
              <FlexItem>
                <ELSButton
                  preventAutoPending
                  isDisabled={!isTitleValid()}
                  onClick={() => {

                    if (!isTitleValid()) {
                      return;
                    }

                    putChatAction({
                      appState,
                      setAppState,
                      appStateRef,
                      chat: {
                        ...props.chat,
                        title: state.title
                      },
                    }).then((response) => {

                      setAppState((prevState) => {
                        return {
                          ...prevState,
                          chats: prevState.chats.map((chat) => {
                            if (chat.id === props.chat.id) {
                              return response;
                            }
                            return chat;
                          })
                        }
                      })
                      props.modalService.closeModal(ChatEditModalId);
                    })
                  }}>
                  Save
                </ELSButton>
              </FlexItem>
            </FlexLayout>
          </div>
        </div>
      </div>
    </div>
  );
};

const enhance = flowRight(
  ELSWithToastService,
  ELSWithModalService,
);

const ChatEditModal: React.FC<ChatEditModalPropsOnly> = enhance(ChatEditModalComponent as React.FC<ChatEditModalProps>);
export default ChatEditModal;
